module.exports = __webpack_public_path__ + "static/media/c6.9b2d073e.gif";